











































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import {SelectBox, SelectMarket, StrategyOfPriceOpt, TaskInfoCalc} from '@/interfaces/global-data';
import {
    IStoreLegalEntityTableParams,
    GetTaskInfo,
    IStoreLegalEntityTableItem,
    PackageCalcConfig,
    TaskData,
    TaskInfoFilterType
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import { IOmnichannelFindMissedStoreParamsRequest } from '@/pages/omnichannel-strategy/types/data';
import OmnichannelConfirmModal from '@/pages/omnichannel-strategy/tabs/strategy/OmnichannelConfirmModal.vue';
import {
    isCalculationDayValid,
    isCalculationDayInRange,
} from '@/utils/salesDepthLimits';
import { Component, Mixins } from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import AutoApprovalTab from '@/components/UI/AutoApprovalTab.vue';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"

@Component({
    components: {
      MultiSelect,
      MarketSelect,
      vSelect,
      HintsContainer,
      CollapseCard,
      CSelect,
      OmnichannelConfirmModal,
      SwitchWithLabel,
      AutoApprovalTab
    },
      methods: {
          replaceTxtToNumber(value) {
              if (value == null) {
                  return null
              } else {
                  return value.replace(/[^\d]/g, '').substring(0, 2);
              }
          },
          replaceCommaFormatter(value) {
              return value.replace(',', '.')
          },
      },
  })
  export default class PackageCalc extends Mixins(LocalData, Toast, Http) {
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('regular.common.all') as string}];
    taskInfo: TaskInfoCalc = {
      storeFormatOptions: [],
      storeRegionOptions: [],
      buyerSegmentOptions: [],
      categoryOptions: [],
      clusterOptions: [],
      groupsOfProduct: [],
      subcategories: [],
      subcategoriesDefault: [],
      psegemnts: [],
    };
    errors = [];
    tableKey = 1;
    searchable: boolean = true;

    tasksLoading: boolean = false;
    isCalculating: boolean = false;
    showMainFilters: boolean = true;
    tasksCount: number = 0;
    showBookmarks: boolean = true;
    private dropDownOpen = false;
    // tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
    private httpExecutor = new HttpExecutor();

    isRegionsSelectModalVisible: boolean = false;
    isOmnichannelConfirmModalVisible: boolean = false;

    regionsModalTableIsLoading: boolean = false;

    regionsModalTableData: any[] = [];

    pagination = {
        current: 1,
        pageSize: 5,
        total: 0,
    };

    legalEntitiesIdsForFilter: any[] = [];
    storeLegalEntityOptions: any[] = [];

    omnichannelConfirmModalRequest: IOmnichannelFindMissedStoreParamsRequest | null = null;
    isOmnichannelModalOkBtnDisabled: boolean = true;

    showRegionsModalTable: boolean = true;
    tableFields: any[] = [
        {
            key: 'storeLegalEntityName',
            dataIndex: 'storeLegalEntityName',
            title: this.$t('regular.columns.npo') as string,
            customRender: (name: any) => name || '-',
            scopedSlots: {
                filterDropdown: 'storeLegalEntityFilter',
                filterIcon: "storeLegalEntityIcon",
            },
            width: '35%',
            ellipsis: true,
        },
        {
            key: 'storeRegionName',
            dataIndex: 'storeRegionName',
            title: this.$t('regular.columns.regionName') as string,
            width: '55%',
            ellipsis: true,
        },
    ];

    mounted() {
      if (this.$packageCalc.selectMarket.id !== -1) {
        const self = this;
        (this.$refs.groupSelectedRef as any).toggleLoading(true);
        (this.$refs.updateRegionsRef as any).toggleLoading(true);
        (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        (this.$refs.formatSelectedRef as any).toggleLoading(true);
        (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        (this.$refs.groupOfProductRef as any).toggleLoading(true);
        (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.productSegmentsRef as any).toggleLoading(true);
        this.getCategoryInfo();
        self.getRegionInfo();
        self.getFormatInfo();
        self.getBuyerSegment();
        self.getClusterInfo();
        self.loadProductsGroup();
        self.loadProductsSubcategories();
        self.loadProductSegments();
      }

      EventBus.$on('calc', this.onCalcEventReceived);
    }

    created() {
        this.httpLoadModuleHints('PackageCalc').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('calc', this.onCalcEventReceived);
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    resetData(type: TaskInfoFilterType) {
      switch (type) {
        case TaskInfoFilterType.group:
          this.$packageCalc.categoriesOfProduct = [];
                this.$packageCalc.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.categoryOptions = [];
          this.taskInfo.subcategories = [];
          this.taskInfo.psegemnts = [];
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.getCategoryInfo(null);
          this.loadProductsSubcategories();
          this.loadProductSegments();
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.category:
                this.$packageCalc.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.subcategories = [];
          this.taskInfo.psegemnts = [];
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.loadProductsSubcategories();
          this.loadProductSegments();
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.subcategory:
                this.$packageCalc.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packageCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
          this.taskInfo.psegemnts = [];
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.loadProductSegments();
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.p_segemnt:
          this.$packageCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.$packageCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.taskInfo.storeFormatOptions = [];
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.getFormatInfo();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.format:
          this.$packageCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.taskInfo.storeRegionOptions = [];
          this.taskInfo.clusterOptions = [];
          this.loadProductSegments();
          this.getRegionInfo();
          this.getClusterInfo();
          break;
        case TaskInfoFilterType.region:
          this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          this.taskInfo.clusterOptions = [];
          this.loadProductSegments();
          this.getClusterInfo();
          break;
      }
    }

    updateProductGroup(groupOfProduct: number[]) {
      if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$packageCalc.groupsOfProduct)) {
        this.$packageCalc.groupsOfProduct = groupOfProduct;
        this.savePackageCalc();
        this.resetData(TaskInfoFilterType.group);
      } else if (this.$packageCalc.groupsOfProduct[0] === 0) {
            this.$packageCalc.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateProductCategory(categories: number[]) {
      if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$packageCalc.categoriesOfProduct)) {
        this.$packageCalc.categoriesOfProduct = categories;
        this.resetData(TaskInfoFilterType.category);
        this.savePackageCalc();
      } else if (this.$packageCalc.categoriesOfProduct[0] === 0) {
            this.$packageCalc.categoriesOfProduct = this.defaultIntSelectBox.map(i => i.value);
        }
    }

    updateProductSegment(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.productSegments)) {
            this.$packageCalc.productSegments = list;
            this.saveEvents();
            this.resetData(TaskInfoFilterType.p_segemnt);
        } else if (this.$packageCalc.productSegments[0] === 0) {
            this.$packageCalc.productSegments = this.defaultIntSelectBox.map(i => i.value);
      }
    }

    updateFormats(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.formatSelected)) {
            this.$packageCalc.formatSelected = list;
            this.resetData(TaskInfoFilterType.format);
            this.savePackageCalc();
        } else if (this.$packageCalc.formatSelected[0] === 0) {
            this.$packageCalc.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.regionSelected)) {
        this.$packageCalc.regionSelected = list;
        this.resetData(TaskInfoFilterType.region);
        this.savePackageCalc();
      } else if (this.$packageCalc.regionSelected[0] === 0) {
          this.$packageCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

      updateClusters(list: number[]) {
          if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.clusterSelected)) {
              this.$packageCalc.clusterSelected = list;
              this.resetData(TaskInfoFilterType.cluster);
              this.savePackageCalc();
          } else if (this.$packageCalc.clusterSelected[0] === 0) {
              this.$packageCalc.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
          }
      }

    updateBuyerSegments(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.buyerSegmentsList)) {
        this.$packageCalc.buyerSegmentsList = list;
        this.savePackageCalc();
      } else if (this.$packageCalc.buyerSegmentsList[0] === 0) {
          this.$packageCalc.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateSubcategories(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.subcategories)) {
        this.$packageCalc.subcategories = list;
        this.savePackageCalc();
        this.resetData(TaskInfoFilterType.subcategory);
      } else if (this.$packageCalc.subcategories[0] === 0) {
          this.$packageCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateSeasons(list: number[]) {
      if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packageCalc.seasonSelected)) {
        this.$packageCalc.seasonSelected = list;
        this.savePackageCalc();
      } else if (this.$packageCalc.seasonSelected[0] === 0) {
          this.$packageCalc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
      }
    }

    updateSelectMarket(market: SelectMarket) {
      if (this.$packageCalc.selectMarket == null || this.$packageCalc.selectMarket.id !== market.id) {
        this.resetPackageCalcData();
        this.$packageCalc.selectMarket = market;
        this.initTask();
        this.savePackageCalc();
        this.$packageCalc.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}
      }
    }

    showCalcProgress(status: string): boolean {
      return (status === 'WriteToFileComplete'
        || status === 'EmptyData'
        || status === 'ExecutionException'
        || status.includes('Error'));
    }

    selectData(): [number[], number[], number[], number[]] {
      const selectSeasons: number[] = (this.$packageCalc.seasonSelected.length === 0 || (this.$packageCalc.seasonSelected.length === 1 && this.$packageCalc.seasonSelected[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packageCalc.seasonSelected)!!;
      const selectRegions: number[] = (this.$packageCalc.regionSelected.length === 0 || (this.$packageCalc.regionSelected.length && this.$packageCalc.regionSelected[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packageCalc.regionSelected)!!;
      const selectBuyerSegment: number[] = (this.$packageCalc.buyerSegmentsList.length === 0 || (this.$packageCalc.buyerSegmentsList.length && this.$packageCalc.buyerSegmentsList[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packageCalc.buyerSegmentsList)!!;
      const selectFormats: number[] = (this.$packageCalc.formatSelected.length === 0 || (this.$packageCalc.formatSelected.length && this.$packageCalc.formatSelected[0] === 0))
        ? []
        // tslint:disable-next-line: no-non-null-assertion
        : LocalData.filterNumberArrays(this.$packageCalc.formatSelected)!!;
      return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    initTask() {
      if (this.$packageCalc.selectMarket.id === -1) {
        return;
      }
      (this.$refs.updateRegionsRef as any).toggleLoading(true);
      (this.$refs.updateSeasonsRef as any).toggleLoading(true);
      (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
      (this.$refs.formatSelectedRef as any).toggleLoading(true);
      (this.$refs.groupSelectedRef as any).toggleLoading(true);
      (this.$refs.clasterSelectedRef as any).toggleLoading(true);
      (this.$refs.groupOfProductRef as any).toggleLoading(true);
      (this.$refs.subcategoriesRef as any).toggleLoading(true);
        (this.$refs.productSegmentsRef as any).toggleLoading(true);

      this.$packageCalc.categoriesOfProduct = [];
      this.$packageCalc.clusterSelected = [];
      this.$packageCalc.formatSelected = [];
      this.$packageCalc.groupsOfProduct = [];
      this.$packageCalc.subcategories = [];
        this.$packageCalc.productSegments = [];
      this.taskInfo.storeFormatOptions = [];
      this.taskInfo.storeRegionOptions = [];
      this.taskInfo.buyerSegmentOptions = [];
      this.taskInfo.categoryOptions = [];
      this.taskInfo.clusterOptions = [];
      this.taskInfo.psegemnts = [];
      this.taskInfo.subcategories = [];
      this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
      const self = this;
      this.getCategoryInfo(() => {
        self.loadProductsGroup();
        self.getRegionInfo();
        self.getFormatInfo();
        self.getBuyerSegment();
        self.getClusterInfo();
        self.loadProductsSubcategories();
        self.loadProductSegments();
      });
    }

    loadProductsGroup() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.groupOfProductRef as any).toggleLoading(false);
          }, 250);
          this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
            return {value: i.id, label: i.name}
          });
          this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('regular.common.all') as string});
        })
        .catch((e) => {
        })
    }

    loadProductsSubcategories() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.subcategoriesRef as any).toggleLoading(false);
          }, 250);
          this.taskInfo.subcategories = filterData.subcategories.map((i) => {
            return {value: i.id, label: i.name}
          });
          this.taskInfo.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
        })
        .catch((e) => {
        })
    }

    getCategoryInfo(cb: any = null) {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.groupSelectedRef as any).toggleLoading(false);
            (this.$refs.updateSeasonsRef as any).toggleLoading(false);
          }, 250);
          this.taskInfo.categoryOptions = filterData.categories.map((i) => {
            return {value: i.id, label: i.name}
          });
          this.taskInfo.categoryOptions.unshift();
          if (typeof cb === 'function') {
            cb();
          }
        })
        .catch((e) => {
        })
    }

    getRegionInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.updateRegionsRef as any).toggleLoading(false);

          }, 500);

          this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
            return {value: i.id, label: i.name};
          });
        })
        .catch((e) => {
        });
    }

    getFormatInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.formatSelectedRef as any).toggleLoading(false);
          }, 500);
          this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
              return {value: i.id, label: i.name};
          });

        })
        .catch((e) => {
        });
    }

    getBuyerSegment() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
            return {value: i.id, label: i.name};
          });

        })
        .catch((e) => {
        });
    }

    getClusterInfo() {
      this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
        .then((data) => {
          const filterData = data.data;
          setTimeout(() => {
            (this.$refs.clasterSelectedRef as any).toggleLoading(false);
          }, 500);

          this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
            return {value: i.id, label: i.name};
          });
        })
        .catch((e) => {
        });
    }

    loadProductSegments() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.productSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.psegemnts = filterData.psegments.map(i => {
                    return {
                        label: i.name,
                        value: i.id
                    };
                });
                this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('regular.common.all') as string });
            })
            .catch(e => {});
    }

    confirmCalc() {
        const filters = this.getCalcFilter();
        this.savePackageCalc();
        this.httpAddPackageCalcTask(filters)
            .then((r) => {
                    this.$log.debug('Create task', r.data);
                    this.showInfo(this.$t('regular.notifications.calcStarted') as string);
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.startCalcFailed') as string);
            })
            .finally(() => {
                this.isCalculating = false;
            });
    }

    clearConfirmData() {
        this.tasksLoading = false;
    }

    loadTasksCount() {
        this.tasksLoading = true;
        this.httpExecutor.executeHttp(this.httpGetPackageTasksCount, this.getCalcFilter())
            .then((r) => {
                if (!r.ignore) {
                    this.tasksLoading = false;
                    this.tasksCount = r.response.data.count;
                }
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.startCalcFailed') as string);
            });
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

    showOptimizationPriceStrategy(): boolean {
        return this.$packageCalc.compensateAllCategories != null && this.$packageCalc.compensateLowerTargets && this.$packageCalc.compensateAllCategories;
    }

    onThompsonSamplingChange(checked: boolean) {
        this.savePackageCalc();
    }

    onUseFixedPricesChange(checked: boolean) {
        this.savePackageCalc();
    }

    onPackageCalcSwitchPersist() {
        requestAnimationFrame(() => this.savePackageCalc());
    }

    get baseChannelScanDepthValidate(): boolean | null {
        if (!this.$packageCalc.recalcOnlyByBaseChannelChanges) {
            return null;
        }
        const depth = this.$packageCalc.baseChannelChangesScanDepthDays;
        return Number.isInteger(depth) && depth >= 1 && depth <= 30;
    }

    private calc() {
        if (this.$packageCalc.selectMarket.id <= 0) {
            this.showError(this.$t('regular.notifications.tradingCompanyNotSelected') as string);
            return;
        }

        const filters = this.getCalcFilter();
        console.log(filters.sendGeneralReportNotification);
        console.log("SEND_NOTIFICATION");
        if (filters.applyOmnichannel) {
            this.checkOmnichannel(filters);
        } else {
            this.isCalculating = true;

            this.callCalculation(filters);
        }
    }

    private callCalculation(filters: PackageCalcConfig) {
        if (LocalData.filterNumberArrays(filters.groupsOfProduct, true) == null
            && LocalData.filterNumberArrays(filters.categories, true) == null) {
            this.isCalculating = false;
            (this.$refs.confirmPackageCalc as any).show();
            return;
        } else {
            this.savePackageCalc();
            this.httpAddPackageCalcTask(filters)
                .then((r) => {
                        this.$log.debug('Create task', r.data);
                        this.showInfo(this.$t('regular.notifications.calcStarted') as string);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.startCalcFailed') as string);
                })
                .finally(() => {
                    this.isCalculating = false;
                });
        }
    }

    private checkOmnichannel(params: PackageCalcConfig) {
        this.omnichannelConfirmModalRequest = {
            tradingNetId: params.tradingId,
            groups: LocalData.filterNumberArrays(params.groupsOfProduct),
            categories: LocalData.filterNumberArrays(params.categories),
            subcategories: LocalData.filterNumberArrays(params.subcategories),
            storeFormats: LocalData.filterNumberArrays(params.storeFormat),
            storeRegions: LocalData.filterNumberArrays(params.storeRegionValues),
            storeClusters: LocalData.filterNumberArrays(params.storeCluster),
        };

        this.isOmnichannelConfirmModalVisible = true;
    }

    private getTaskInfo(filterType: TaskInfoFilterType): GetTaskInfo {
      const [, selectRegions, , selectFormats] = this.selectData();
      return {
        type: filterType,
        tradingId: this.$packageCalc.selectMarket.id,
        categories: LocalData.filterNumberArrays(this.$packageCalc.categoriesOfProduct),
        groups: LocalData.filterNumberArrays(this.$packageCalc.groupsOfProduct),
        subcategory: LocalData.filterNumberArrays(this.$packageCalc.subcategories, true),
            productSegments: LocalData.filterNumberArrays(this.$packageCalc.productSegments, true),
        segments: null,
        storeFormat: selectFormats,
        storeCluster: this.$packageCalc.clusterSelected,
        storeRegion: selectRegions,
        byReports: false,
      }
    }

  private getCalcFilter(): PackageCalcConfig {
    // tslint:disable-next-line: no-non-null-assertion
    let groups = LocalData.filterNumberArrays(this.$packageCalc.groupsOfProduct)!!;
    // Если не выбрали ни одной группы и оставили опцию "Все"
    if (groups.length === 0) {
      groups = this.taskInfo.groupsOfProduct.map((group) => {
        // tslint:disable-next-line: no-non-null-assertion
        return group.value!!
      });
      // Удаляем из массива опцию "Все"
      groups.splice(0, 1)
    }
    const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectData();
    const selectClusters: number[] = (this.$packageCalc.clusterSelected.length === 0 || (this.$packageCalc.clusterSelected.length && this.$packageCalc.clusterSelected[0] === 0))
        // tslint:disable-next-line: no-non-null-assertion
        ? [] : LocalData.filterNumberArrays(this.$packageCalc.clusterSelected)!!;
    const sendReportToFtp = this.$packageCalc.sendReportToFtp;
    return {
      coefficientK1: this.$packageCalc.selectCoefficent.value.k1,
      coefficientK2: this.$packageCalc.selectCoefficent.value.k2,
// tslint:disable-next-line: no-non-null-assertion
      categories: LocalData.filterNumberArrays(this.$packageCalc.categoriesOfProduct)!!,
      productSegments: LocalData.filterNumberArrays(this.$packageCalc.productSegments)!!,
      storeCluster: selectClusters,
      seasonValues: selectSeasons,
      buyerSegments: selectBuyerSegment,
      storeRegionValues: selectRegions,
      storeFormat: selectFormats,
      tradingId: this.$packageCalc.selectMarket.id,
      calculationDay: +this.$packageCalc.calculationDay,
// tslint:disable-next-line: no-non-null-assertion
      groupsOfProduct: groups,
// tslint:disable-next-line: no-non-null-assertion
      priceOpt: this.$packageCalc.selectCoefficent.value.enum!,
      subcategories: LocalData.filterNumberArrays(this.$packageCalc.subcategories),
      separateSubcategories: this.$packageCalc.separateSubcategories,
      separateClusters: this.$packageCalc.separateClusters,
      packageCalc: true,
      categoryStrategy: this.$packageCalc.categoryStrategy.value,
      sendReportToFtp,
      makeGeneralReport: this.$packageCalc.makeGeneralReport,
      calcWithBatchNumber: true,
      backBasketPart: this.$packageCalc.backBasketPart,
      compensateAllCategories: this.$packageCalc.compensateAllCategories,
      thompsonSampling: this.$packageCalc.thompsonSampling,
      revaluationCalculateParams: this.$packageCalc.revaluationCalculateParams,
      compensateLowerTargets: this.$packageCalc.compensateLowerTargets,
      applyOmnichannel: this.$packageCalc.applyOmnichannel,
      recalcOnlyByBaseChannelChanges: this.$packageCalc.recalcOnlyByBaseChannelChanges,
      baseChannelChangesScanDepthDays: this.$packageCalc.baseChannelChangesScanDepthDays,
      skipZeroRemainsRecalc: this.$packageCalc.skipZeroRemainsRecalc,
      sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
      isFixPricePromo: this.$packageCalc.isFixPricePromo,
      useSkuRotation: false,
      useFixedPrices: this.$packageCalc.useFixedPrices,
      autoApprovalParams: this.$packageCalc.autoApprovalParams,
    };
  }

    get saveState(): boolean {
// tslint:disable-next-line: no-non-null-assertion
      const filteredGroups = LocalData.filterNumberArrays(this.$packageCalc.groupsOfProduct)!!.length;
// tslint:disable-next-line: no-non-null-assertion
      const filteredCategories = LocalData.filterNumberArrays(this.$packageCalc.categoriesOfProduct)!!.length;
      return (filteredGroups === 1 && filteredCategories === 1) || (filteredGroups === 1 && filteredCategories === 0) || (filteredGroups === 0 && filteredCategories === 1);
    }

    get calculationDayValidate(): boolean {
      return isCalculationDayValid(this.$packageCalc.calculationDay);
    }

    get calculationDayInvalidMessage(): string {
      if (!isCalculationDayInRange(this.$packageCalc.calculationDay)) {
        return this.$t('regular.validation.forecastPeriodMaxDays') as string;
      }
      return this.$t('regular.validation.numberGtZero') as string;
    }

    private get isCalcButtonDisabled(): boolean {
        if (this.$packageCalc.selectMarket != null) {
            const state = this.calculationDayValidate && this.baseChannelScanDepthValidate !== false;
            return !state
        }
        return true;
    }

    get isGroupsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$packageCalc.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

      get isCategoriesSelected(): boolean {
          const categories = LocalData.filterNumberArrays(this.$packageCalc.categoriesOfProduct);
          return categories != null && categories.length > 0;
      }

    get isSubcategorySelected(): boolean {
        const subcategory = LocalData.filterNumberArrays(this.$packageCalc.subcategories);
        return subcategory != null && subcategory.length!! > 0;
    }

      get isFormatSelected(): boolean {
          const formats = LocalData.filterNumberArrays(this.$packageCalc.formatSelected);
          return formats != null && formats.length > 0;
      }

      get isRegionsSelected(): boolean {
          const regions = LocalData.filterNumberArrays(this.$packageCalc.regionSelected);
          return regions != null && regions.length > 0;
      }

    get isClustersSelected(): boolean {
        const selectClusters: number[] = (this.$packageCalc.clusterSelected.length === 0 || (this.$packageCalc.clusterSelected.length && this.$packageCalc.clusterSelected[0] === 0))
// tslint:disable-next-line: no-non-null-assertion
                ? [] : LocalData.filterNumberArrays(this.$packageCalc.clusterSelected)!!;
        return selectClusters.length > 0;
    }

      get backBasketPartValidate(): boolean {
          if (this.$packageCalc.backBasketPart != null) {
              return this.$packageCalc.backBasketPart >= 0 && this.$packageCalc.backBasketPart <= 100;
          }
          return false;
      }

    get rowSelection() {
        return {
            onChange: (selectedRowKeys: string[], selectedRows: IStoreLegalEntityTableItem[]) => {
                if (!selectedRows.length || selectedRows.length === this.taskInfo.storeRegionOptions.length) {
                    this.updateRegions([0]);
                } else {
                    this.updateRegions([...new Set(selectedRows.map(row => row.storeRegionId))]);
                }
            },
            getCheckboxProps: (tableRow: IStoreLegalEntityTableItem) => ({
                props: {
                    defaultChecked: this.$packageCalc.regionSelected.includes(tableRow.storeRegionId),
                },
            }),
        };
    }

    get selectedRegionsObjects() {
        if (this.taskInfo.storeRegionOptions.length) {
            if (!this.$packageCalc.regionSelected.length || this.$packageCalc.regionSelected[0] === 0) {
                return [{
                    label: this.$t('regular.common.all') as string,
                    value: 0,
                }]
            } else {
                return this.$packageCalc.regionSelected.map(regionValue => this.taskInfo.storeRegionOptions.find(optionObj => optionObj.value === regionValue));
            }
        }

        return [];
    }

      openRegionsSelectModal() {
          const rect = (this.$refs.contentParams as any).getBoundingClientRect();

          this.isRegionsSelectModalVisible = true;

          this.$nextTick(() => {
              const regionsSelectModal: HTMLElement = document.querySelectorAll('#regionsSelectModal .modal-dialog')[0] as HTMLElement;

              if (regionsSelectModal) {
                  regionsSelectModal.style.top = `${rect.top - 28}px`;
                  regionsSelectModal.style.left = `${rect.left}px`;
                  regionsSelectModal.style.width = `${rect.width}px`;
              }
          });

          this.fetchData(true);
      }

      fetchData(isNeedFetchFilterOptions: boolean = false) {
          this.regionsModalTableIsLoading = true;

          if (this.$packageCalc.selectMarket) {
              this.regionsModalTableIsLoading = true;

              const params = this.filterParams();

              this.httpGetRegionsAndLegalEntities(params)
                  .then(response => {
                      if (response && response.data) {
                          this.regionsModalTableData = response.data.regionStoreLegalEntities;
                          this.pagination.total = response.data.totalSize;
                      }
                  })
                  .finally(() => {
                      this.regionsModalTableIsLoading = false;
                  });

              if (isNeedFetchFilterOptions) {
                  this.httpGetLegalOptions({tradingId: params.tradingId})
                      .then(response => {
                          if (response && response.data) {
                              this.storeLegalEntityOptions = response.data.storeLegalEntityOptions
                                  .filter(option => !option.id && option.name)
                                  .map(option => ({ value: option.id, label: option.name }));
                          }
                      })
                      .finally(() => {

                      });
              }
          }
      }

      filterParams(): IStoreLegalEntityTableParams {
          return {
              tradingId: this.$packageCalc.selectMarket ? this.$packageCalc.selectMarket.id : -1,
              page: this.pagination.current - 1,
              size: this.pagination.pageSize,
              storeRegionIds: this.taskInfo.storeRegionOptions.map(item => item.value).join(','),
              legalEntitiesIds: this.legalEntitiesIdsForFilter.join(','),
          };
      }

      handleTableChange(pagination?: any) {
          if (pagination) {
              this.pagination.current = pagination.current;
              this.pagination.pageSize = pagination.pageSize;
          } else {
              this.pagination.current = 1;
          }

          this.fetchData();
      }

      removeRegion(regionId: number) {
          const valuesForUpdate = this.$packageCalc.regionSelected.filter(id => id !== regionId);

          this.updateRegions(valuesForUpdate.length ? valuesForUpdate : [0]);

          this.showRegionsModalTable = false;

          this.$nextTick(() => {
              this.showRegionsModalTable = true;
          })
      }

      handleHideOmnichannelModal() {
          this.isOmnichannelConfirmModalVisible = false;
          this.isOmnichannelModalOkBtnDisabled = true;
      }

      handleOmnichannelModalOkBtnClick() {
          this.isCalculating = true;

          this.handleHideOmnichannelModal();

          this.callCalculation(this.getCalcFilter());
      }
  }
